import {
  WORKFLOW_CONDITION_CONTAINS,
  WORKFLOW_CONDITION_EQUALS,
  WORKFLOW_CONDITION_NOT_EQUAL,
  WORKFLOW_CONDITION_NOT_NULL_OR_EMPTY,
  WORKFLOW_CONDITION_NULL_OR_EMPTY
} from 'Constants/'
import { FormElement, Select } from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const textConditions = [
  {
    value: WORKFLOW_CONDITION_CONTAINS,
    label: 'Load.AutomationWorkflow.TriggerCondition-3'
  },
  {
    value: WORKFLOW_CONDITION_EQUALS,
    label: 'Load.AutomationWorkflow.TriggerCondition-7'
  },
  {
    value: WORKFLOW_CONDITION_NOT_EQUAL,
    label: 'Load.AutomationWorkflow.TriggerCondition-12'
  },
  {
    value: WORKFLOW_CONDITION_NOT_NULL_OR_EMPTY,
    label: 'Load.AutomationWorkflow.TriggerCondition-28'
  },
  {
    value: WORKFLOW_CONDITION_NULL_OR_EMPTY,
    label: 'Load.AutomationWorkflow.TriggerCondition-29'
  }
]

const InputIdFieldFilterNumeric = () => {
  const intl = useIntl()
  const [isDirty, setIsDirty] = useState(false)

  const { IdFieldFilter, FieldType } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleIdFiledFilterChange = (value) => {
    setWorkflowDetailsState((prev) => ({ ...prev, IdFieldFilter: value }))
    setIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const idFieldFilterOptions = useMemo(() => {
    return textConditions.map(({ label, value }) => ({
      value,
      label: intl.formatMessage({ id: label })
    }))
  }, [FieldType])

  const invalid = isDirty && !IdFieldFilter

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.SelectFieldConditionLabel'
      })}
      required
      feedback={invalid ? requiredFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <Select
        value={IdFieldFilter}
        options={idFieldFilterOptions}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.SelectTypeConditionPlaceholder'
        })}
        onChange={handleIdFiledFilterChange}
        error={invalid}
      />
    </FormElement>
  )
}

export default InputIdFieldFilterNumeric
